<script>
	/**
	 * 詳細画面パーツ.<br>
	 * メモ.<br>
	 * @module js\common\inputEdit.mixin.vue
	 **/
import emitter from 'js/common/emitter';
import Migrating from 'js/common/migrating';

// フォーム入力制限の定数ファイル読み込み
import * as comData from 'js/const/constants';
const NUMBER = "number"; // 正数
const DECIMAL = "decimal"; // 小数
const TEXT = "text"; // テキスト
const PASSWORD = "password"; //パスワード
const PASSWORD2 = "password2"; //パスワード
const HALF_WIDTH = "half-width"; // 半角英数字のみ
const HALF_WIDTH_MARK = "half-width-mark"; // 半角英数字記号のみ
const TELEPHONE = "telephone"; // 電話番号
const READ_ONLY = "read-only"; // リードのみテキスト
const HIRAGANA = "hiragana"; // ひらがな
const ZIP_CODE = "zip-code"; // 郵便番号
const INTEGRAL_NUMBER = "integral_number"; // 整数(マイナス許容)
const IP_ADDRESS = "ip-address"; // IPアドレス
const TIME_TEXT = "time"; // 時刻(4桁)
const FILE_NAME = "file-name"; // 半角英数字記号(アンダーバー、ハイフン、ドットのみ許容)

	/**
	 * 入力制限数値.
	 * @module js\parts_unit\inputEdit.vue
	 * @param {string[]} value - Disabled component
	 * @param {number} r_max_length - Required, need two way
	 * @param {number} r_max_fra_length - 
	 * @param {number} r_placeholder - 
	 * @param {number} r_disabled - 
	 * @param {string[]} r_type - 
	 * @param {string[]} r_input_class - 
	 */
export default {
	mixins: [
		emitter,
		Migrating
	],
	props:{
		'value': {},
		'r_placeholder': {
			type:String,
			default: ""
		},
		'r_disabled': {
			type:Boolean,
			default:false
		},
		'r_type': {
			type:String,
			default: ""
		},
		'r_max_length': {
			type:[Number,String],
			default: 30
		},
		'r_max_code':{
			type:[Number,String],
			default: ""
		},
		'r_min_code':{
			type:[Number,String],
			default: -999999
		},
		// タイプが小数'DECIMAL'のときのみ使用
		'r_max_fra_length':{
			type:[Number,String],
			default: 2
		},
		// タイプが整数'number'、小数'decimal'のときのみ使用
		// ゼロ埋めを行うかのフラグ
		'r_is_zero_fill':{
			type:Boolean,
			default:false
		},
		'r_input_class': String,
		'validateEvent': {
			type: Boolean,
			default: true
		},
		'r_readonly':false,
		'r_value':null,
		// 値が変更されたかのチェックを文字列で行うか
		// falseだと '1' == '01' と判定されることがある
		// 影響範囲が広いため基本的にはfalse
		'r_data_change_check_str': {
			type: Boolean,
			default: false
		},
		'r_text_footer': {
			type: String,
			default: ''
		},
	},
	data: function (){
		return{
			m_inputdata: "",
			m_bReadOnly: false,
		}
	},
	mounted:function(){
		this.initialize();
	},
	computed: {
		_elFormItemSize() {
			return (this.elFormItem || {}).elFormItemSize;
		},
		validateState() {
			return this.elFormItem ? this.elFormItem.validateState : '';
		},
		max_len:function(){
			var temp = this.r_max_length;
			if(typeof this.r_max_length == 'string'){
				temp = Number(temp);
			}
			if(temp > 0){
				return temp;
			}
			return 1000;
		},
		inputType:function(){
			var type = "text"
			switch ( this.r_type ) {
				case NUMBER: // 正数
				case DECIMAL: // 小数
				case TELEPHONE:// 電話番号
				case ZIP_CODE: // 郵便番号
				case INTEGRAL_NUMBER: // 整数 
				case TIME_TEXT: // 時刻(4桁)
					// 携帯のキーボード入力が数値入力にするためにtelを指定
					type = "tel";
					break;
				case PASSWORD: //パスワード
				case PASSWORD2: //パスワード
					type = "password";
					break;
				case "":
				case TEXT: // テキスト
				case HALF_WIDTH: // 半角テキストのみ
				case HALF_WIDTH_MARK: // 半角英数字記号のみ
				case IP_ADDRESS: // IPアドレス
				case FILE_NAME: // 半角英数字記号(アンダーバー、ハイフン、ドットのみ許容)
				default:
					type = "text"
					break;
			}
			return type;
		},
		pattern:function(){
			var pattern = "";
			// switch ( this.r_type ) {
			// 	case NUMBER: // 正数
			// 		pattern = "^([0-9]{0,"+ this.max_len + "})$";
			// 		break;
			// 	case DECIMAL: // 小数
			// 		pattern = "(^[0-9]{0,"+ this.max_len + "}[.]{1,1}[0-9]{0,"+ this.r_max_fra_length + "}$)|(^[0-9]{0,"+ this.max_len + "}$)";
			// 		break;
			// 	case TELEPHONE:// 電話番号
			// 		pattern = "^[0-9\\-]{0,"+this.max_len+"}$";
			// 		break;
			// 	case TEXT: // テキスト
			// 		var kigou = comData.KIGOU;
			// 		pattern = "[^" + kigou+ "]{0,"+ this.max_len + "}$";
			// 		break;
			// 	case PASSWORD: //パスワード
			// 	case HALF_WIDTH: // 半角英数字のみ
			// 		pattern = "^[a-zA-Z0-9]{0,"+ this.max_len + "}$";
			// 		break;
			// 	case HALF_WIDTH_MARK: // 半角英数字記号のみ
			// 	case PASSWORD2: //パスワード2 半角英数+記号
			// 		pattern = "^[\x20-\x7E]{0,"+ this.max_len + "}$";
			// 		break;
			// 	case HIRAGANA: // ひらがなのみ
			// 		pattern = "^[\u3041-\u3096]{0,"+ this.max_len + "}$|^[Ａ-Ｚｂ-ｚ]{0,"+ this.max_len + "}$";
			// 		break;
			// 	case ZIP_CODE: // 郵便番号
			// 		pattern = "^[0-9]{0,3}-?[0-9]{0,4}$";
			// 		break;
			// 	case INTEGRAL_NUMBER: // 整数(マイナス許容)
			// 		pattern = "^[-]?([0-9]{0,"+ this.max_len + "})$";
			// 		break;
			// 	case IP_ADDRESS: // IPアドレス
			// 		pattern = "^([0-9]{0,3}\\.){0,3}[0-9]{0,3}?$";
			// 		break;
			// 	case TIME_TEXT: // 時刻(4桁)
			// 		pattern = "^([0-9]{0,"+ this.max_len + "})$";
			// 		break;
			// 	case FILE_NAME: // 半角英数字記号(アンダーバー、ハイフン、ドットのみ許容)
			// 		pattern = "^[a-zA-Z0-9\x2D\x2E\x5F]{0,"+ this.max_len + "}$";
			// 		break;
			// 	case "":
			// 	default:
			// 		return null;
			// }
			return pattern;
		},
		autocomplete:function() {
			var autocomplete = "";
			switch ( this.r_type ) {
				case PASSWORD: //パスワード
				case PASSWORD2: //パスワード
					autocomplete = "new-password";
					break;
				default:
					autocomplete = "off";
					break;
			}
			return autocomplete;
		}
	},
	watch: {
		value: function (newValue) {
			var val = newValue;
			if (val != undefined) {
				if (this.r_data_change_check_str) {
					// 文字列として判定
					if (''+this.m_inputdata != ''+val) {
						this.m_inputdata = val;
					}
				} else {
					if (this.m_inputdata != val) {
						this.m_inputdata = val;
					} else {
						if ((this.m_inputdata === 0 || this.m_inputdata == '0') && val === '') {
							this.m_inputdata = val;
						}
					}
				}
			}
		},
		r_value: function (newValue) {
			var val = newValue;
			if (val != undefined) {
				if (this.r_data_change_check_str) {
					// 文字列として判定
					if (''+this.m_inputdata != ''+val) {
						this.m_inputdata = val;
					}
				} else {
					if (this.m_inputdata != val) {
						this.m_inputdata = val;
					}
				}
			}
		},
		r_type:function(){
			this.updateReadOnly();
		},
		r_readonly:function(){
			this.updateReadOnly();
		}
	},
	methods: {
		//! 初期化
		initialize:function(){
			this.initializeSub();
		},
		//! 初期化の実処理
		initializeSub:function(){
			this.m_inputdata= this.value;
			if(this.m_inputdata == undefined) {
				this.m_inputdata="";
			}

			if(this.r_value){
				this.m_inputdata = this.r_value;
			}

			this.updateReadOnly();
		},
		updateReadOnly:function(){
			this.m_bReadOnly =false;
			switch ( this.r_type ) {
				case READ_ONLY: // ロードのみ
					this.m_bReadOnly = true;
					break;
				default:
					break;
			}
			if(this.r_readonly){
				this.m_bReadOnly = true;
			}
		},
		convertDispText:function(txt){
			switch ( this.r_type ) {
				case NUMBER: // 正数
					if (this.r_is_zero_fill) {
						txt = txt + "";
						if( txt.length > 0  && Number(txt)>=0)
						{// 入力されている場合のみ
							while( txt.length < this.max_len ) {
								txt = "0" + txt;
							}
						}
					}
					break;
				case DECIMAL: // 小数
				case TELEPHONE:// 電話番号
				case "":
				case TEXT: // テキスト
				case PASSWORD: //パスワード
				case PASSWORD2: //パスワード
				case HALF_WIDTH: // 半角テキストのみ
				case HALF_WIDTH_MARK: // 半角英数字記号のみ
				case IP_ADDRESS: // IPアドレス
				default:
					break;
			}
			return txt;
		},
		/**
		 * フォーカスアウト
		 * @param {object} value - onBlur event
		 * @method onBlur
		 */
		onBlur: function(e) {
			switch ( this.r_type ) {
				case NUMBER: // 正数
					if (this.r_is_zero_fill) {
						this.doBlurNum();
					}
					break;
				case DECIMAL: // 小数
					if (this.r_is_zero_fill) {
						this.doBlurDecimal();
					}
					break;
				case HIRAGANA: // ひらがなのみ
					this.doBlurHiragana();
					break;
				case TIME_TEXT: // 時刻(4桁)
					this.doBlurTime();
					break;
				case TELEPHONE:// 電話番号
				case "":
				case TEXT: // テキスト
				case PASSWORD: //パスワード
				case PASSWORD2: //パスワード
				case HALF_WIDTH: // 半角テキストのみ
				case HALF_WIDTH_MARK: // 半角英数字記号のみ
				case IP_ADDRESS: // IPアドレス
				default:
					break;
			}

			this.$emit('blur', e);
			if (this.validateEvent) {
				this.dispatch('ElFormItem', 'el.form.blur', [this.currentValue]);
			}
		},
		/**
		 * フォーカスイン
		 * @param {object} value - onFocus event
		 * @method onFocus
		 */
		onFocus: function(e) {
			switch ( this.r_type ) {
				case NUMBER: // 正数
					if (this.r_is_zero_fill) {
						this.doFocusNum();
					}
					break;
				case DECIMAL:// 小数
					if (this.r_is_zero_fill) {
						this.doFocusDecimal();
					}
					break;
				case TELEPHONE:// 電話番号
					break;
				case READ_ONLY: // 読み取り専用
					break;
				case "":
				case TEXT: // テキスト
				case PASSWORD: //パスワード
				case PASSWORD2: //パスワード
				case HALF_WIDTH: // 半角テキストのみ
				case HALF_WIDTH_MARK: // 半角英数字記号のみ
				case IP_ADDRESS: // IPアドレス
				case TIME_TEXT: // 時刻(4桁)
				default:
					break;
			}
			this.$emit('focus', e);
		},
		/**
		 * 入力値チェック
		 * @param {$event} event - onKeyup event
		 * @method updateValue
		 */
		updateValue: function ( val, event) {
			var value = "";
			var isCheck = true;
			switch ( this.r_type ) {
				case NUMBER: // 正数
				case DECIMAL: // 小数
				case TELEPHONE:// 電話番号
				case PASSWORD: //パスワード
				case PASSWORD2: //パスワード
				case HALF_WIDTH: // 半角英数字のみ
				case HALF_WIDTH_MARK: // 半角英数字記号のみ
				case ZIP_CODE: // 郵便番号
				case INTEGRAL_NUMBER: // 整数
				case IP_ADDRESS: // IPアドレス
				case TIME_TEXT: // 時刻(4桁)
				case FILE_NAME: // 半角英数字記号(アンダーバー、ハイフン、ドットのみ許容)
					isCheck = this.opt(val,event);
					value = event.target.value;
					break;
				case HIRAGANA: // ひらがなのみ
				case TEXT: // テキスト
				case "":
				default:
					value = event.target.value;
					break;
			}
			if(value != undefined){
				this.m_inputdata = value;
			}else{
				this.m_inputdata = "";
			}
			if (isCheck) {
				this.$emit('input', value );
			}
		},
		/**
		 * キーボードが押された際のイベント
		 * @event components/com/InputNum/onKeyup
		 * @param {string[]} event - onKeyup event
		 * @returns event
		 */
		onKeyup: function (event) {
			this.$emit( 'keyup', event);
		},

		// 正数値入力チェック系
		doFocusNum: function() {
			var temp = this.value + "";
			while( temp.indexOf("0") == 0 ){
				temp = temp.substr(1);
			}
			if ( temp.length == 0 && this.value != "" ) {
				temp = 0;
			}
			this.m_inputdata = temp;
		},
		doBlurNum: function() {
			var temp = this.value + "";
			if( temp.length > 0 )
			{// 入力されている場合のみ
				while( temp.length < this.max_len ) {
					temp = "0" + temp;
				}
			}
			this.m_inputdata = temp;

			this.$emit('input', this.m_inputdata );
		},
		// 小数値入力チェック系
		doFocusDecimal: function() {
			var temp = this.value + "";
			while( temp.indexOf("0") == 0 ){
				temp = temp.substr(1);
			}
			this.m_inputdata = temp;
		},
		doBlurDecimal: function() {
			var temp = this.value + "";
			if( temp.length > 0 )
			{// 入力されている場合のみ
				while( temp.length < this.max_len ) {
					temp = "0" + temp;
				}
			}
			this.m_inputdata = temp;
			this.$emit('input', this.m_inputdata );
		},
		doBlurHiragana: function() {
			var temp = this.value + "";
			if( temp.length > 0 )
			{// 入力されている場合のみ
				var re = new RegExp(this.pattern);
				var result = re.exec(temp);
				if (result) {
					this.m_inputdata = temp;
				} else {
					// バリデーションエラーの場合、許可されている最大の長さにする
					this.m_inputdata = temp.slice( 0, this.max_len );
					this.$emit('input', this.m_inputdata );
				}
			}
		},
		// フォーカスアウト時入力値補正(時刻4桁)
		doBlurTime: function(){
			let temp = this.value + '';
			if(temp.length > 0 && temp.length < 4){
				// 入力されている場合は0埋め4桁に補正する
				temp = temp.padStart(4, '0');
				this.m_inputdata = temp;

				this.$emit('input', this.m_inputdata);
			}
		},
		onChange:function(obj){
			this.$emit('change', obj );
		},
		/**
		 * バリデーション成功時trueを返す。
		 * エラーはfalse
		 */
		opt:function(oldVal,e){
			if ( e.target.value != "" ) {
				var re = new RegExp(e.target.pattern);
				var result = re.exec(e.target.value);
				if (result) {
					return true;
				} 
				e.target.value = oldVal
				return false;
			} 
			// 空白の場合
			return true;
		}
	},
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/common/inputEdit.mixin.vue